module.exports = __webpack_public_path__ + "media/newstyle/images/congratulations-aus-c27e8a04de0976250e40fe056738646b.png";